import React, { useState, useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { IoArrowBackCircleSharp } from "react-icons/io5";
import { useToast } from "../context/ToastContext";
import { API } from "../Contstant/constant";

export default function AddProduct() {
  const location = useLocation();
  const { showToast } = useToast();

  let idd = location.state?.idd || null;
  const [ProductImage, setProductImage] = useState([]);
  const [EditProduct, setEditProduct] = useState(null);
  const [mainImageIndex, setMainImageIndex] = useState(0);
  const [errors, setErrors] = useState({});
  const [removedImages, setRemovedImages] = useState([]);
  const [slugTouched, setSlugTouched] = useState(false);
  const [discription, setDiscription] = useState("");
  const [previewImages, setPreviewImages] = useState([]);
  const [comboItems, setComboItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [ProductFormData, setProductFormData] = useState({
    ProductName: "",
    RealPrice: "",
    sku: "",
    OfferPrice: "",
    category: "",
    realprice: "",
    packsize: "",
    unit: "",
    subtitle: "",
    order: "",
    stockQuantity: "",
    status: true,
    page_slug: "",
    servingSize: "",
    servingsPerContainer: "",
  });

  const INPUT_FIELDS = [
    { name: "ProductName", placeholder: "Product name", col: 6, type: "text" },
    { name: "page_slug", placeholder: "Page Slug", col: 6, type: "text" },
    { name: "sku", placeholder: "SKU (Unique product code)", col: 6, type: "text" },
    { name: "subtitle", placeholder: "Product subtitle (optional)", col: 12, type: "text" },
    { name: "order", placeholder: "Display Product Position", col: 4, type: "number" },
    { name: "realprice", placeholder: "Regular price", col: 4, type: "number" },
    { name: "OfferPrice", placeholder: "Sale price", col: 4, type: "number" },
    { name: "packsize", placeholder: "Pack size / Quantity", col: 4, type: "number" },
    { name: "servingSize", placeholder: "Serving Size (optional)", col: 4, type: "text" },
    { name: "servingsPerContainer", placeholder: "Servings Per Container (optional)", col: 4, type: "text" }
  ];

  const SELECT_FIELDS = [
    {
      name: "unit",
      col: 4,
      placeholder: "Choose unit...",
      options: [
        "Gms",
        "Kg",
        "Ltr",
        "Pcs",
        "Gummies",
        "ml",
        "package",
        "Box",
        "Pack",
        "Bottle",
        "Sachet",
      ],
    },
    {
      name: "category",
      col: 4,
      placeholder: "Choose category...",
      options: categories.map(cat => ({ label: cat.name, value: cat.name })),
    },
    {
      name: "status",
      col: 4,
      placeholder: "Select status",
      options: [
        { label: "Active", value: true },
        { label: "Inactive", value: false }
      ]

    }
  ];

  const validateForm = () => {
    let newErrors = {};

    if (!ProductFormData.ProductName.trim()) {
      newErrors.ProductName = "Product name is required";
    }

    if (!ProductFormData.sku.trim()) {
      newErrors.sku = "SKU is required";
    }

    if (!ProductFormData.realprice) {
      newErrors.realprice = "Regular price is required";
    }

    if (!ProductFormData.OfferPrice) {
      newErrors.OfferPrice = "Offer price is required";
    }

    if (!ProductFormData.category) {
      newErrors.category = "Category is required";
    }

    if (!ProductFormData.packsize) {
      newErrors.packsize = "Pack size is required";
    }

    if (!ProductFormData.unit) {
      newErrors.unit = "Unit is required";
    }

    if (ProductFormData.order === "" || ProductFormData.order === null) {
      newErrors.order = "Product order is required";
    }

    if (!discription) {
      newErrors.discription = "Description is required";
    }

    if (ProductImage.length === 0 && previewImages.length === 0) {
      newErrors.productimage = "At least one image is required";
    }


    setErrors(newErrors);


    if (Object.keys(newErrors).length > 0) {
      const firstErrorField = Object.keys(newErrors)[0];
      const element = document.querySelector(`[name="${firstErrorField}"]`);
      if (firstErrorField === "discription") {
        const element = document.getElementById("description-editor");
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }

      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
        element.focus();
      }
    }

    return Object.keys(newErrors).length === 0;
  };


  useEffect(() => {
    const fetchCategories = async () => {
      try {
        let response = await axios.get(`${API}/api/category/getdata`);
        setCategories(response.data.categories);

      } catch (error) {
        console.error(error);
      }
    };
    fetchCategories();
  }, []);
  useEffect(() => {
    if (idd) {
      getProduct();
    }
  }, [idd]);

  const getProduct = async () => {
    try {
      let response = await axios.get(`${API}/api/product/getbyproductbyid/${idd}`);
      setEditProduct(response.data);
      console.log("Populating form with product data:", response.data);

    } catch (error) {
      console.log("Error fetching product data", error);
    }
  };

  const handleChange = (e) => {
    const { name, value, type } = e.target;

    if (name === "page_slug") {
      setSlugTouched(true);
    }

    setProductFormData(prev => ({
      ...prev,
      [name]:
        type === "number"
          ? value === "" ? "" : Number(value)
          : value,
    }));
  };

  useEffect(() => {
    if (!ProductFormData.sku && ProductFormData.ProductName) {
      const autoSKU =
        "GDS-" +
        ProductFormData.ProductName
          .replace(/\s+/g, "-")
          .toUpperCase()
          .slice(0, 10) +
        "-" +
        Date.now().toString().slice(-4);

      setProductFormData(prev => ({
        ...prev,
        sku: autoSKU
      }));
    }
  }, [ProductFormData.ProductName]);


  useEffect(() => {
    if (!slugTouched && ProductFormData.ProductName) {
      setProductFormData(prev => ({
        ...prev,
        page_slug: generateSlug(ProductFormData.ProductName),
      }));
    }
  }, [ProductFormData.ProductName]);


  const handleEditorChange = (event, editor) => {
    const data = editor.getData();
    setDiscription(data);
  };

  const handleChangeImage = (e) => {
    const files = Array.from(e.target.files);

    setProductImage(prev => [...prev, ...files]);

    const previews = files.map(file => ({
      preview: URL.createObjectURL(file),
      fileName: file.name,
      isMain: false,
      public_id: null,
    }));

    setPreviewImages(prev => [...prev, ...previews]);
  };

  const AddProduct = async () => {
    if (!validateForm()) return;
    try {
      if (!ProductFormData.category || !ProductFormData.packsize || !ProductFormData.ProductName ||
        !ProductFormData.realprice || !ProductFormData.OfferPrice
      ) {
        alert("Please fill all required fields.");
        return;
      }

      const formdata = new FormData();
      formdata.append("order", ProductFormData.order);
      formdata.append("category", ProductFormData.category);
      formdata.append("discription", discription);
      formdata.append("productName", ProductFormData.ProductName);
      formdata.append("realPrice", ProductFormData.realprice);
      formdata.append("offerPrice", ProductFormData.OfferPrice);
      formdata.append("packsize", ProductFormData.packsize);
      formdata.append("unit", ProductFormData.unit);
      formdata.append("subtitle", ProductFormData.subtitle);
      formdata.append("sku", ProductFormData.sku);
      formdata.append("mainImageIndex", mainImageIndex);
      formdata.append(
        "servingsPerContainer",
        ProductFormData.servingsPerContainer?.trim() || ""
      );

      formdata.append(
        "servingSize",
        ProductFormData.servingSize?.trim() || ""
      );
      formdata.append("stockQuantity", ProductFormData.stockQuantity);
      formdata.append(
        "combo",
        JSON.stringify(
          comboItems.map(item => ({
            productName: item.product,
            quantity: item.quantity,
          }))
        )
      );
      formdata.append("status", ProductFormData.status);
      formdata.append("page_slug", ProductFormData.page_slug);


      if (ProductImage.length > 0) {
        ProductImage.forEach((image) => {
          formdata.append("productimage", image);
        });
      }

      let response = await axios.post(
        `${API}/api/product/addproduct`,
        formdata,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 200) {
        showToast("Product added successfully", "success");
        window.location.assign("/dashboard");
      }
    } catch (error) {
      if (error.response?.data?.message) {
        showToast(error.response.data.message, "error");
      } else {
        showToast("Something went wrong", "error");
      }
    }

  };

  const handleUpdate = async () => {
    try {
      const formdata = new FormData();
      formdata.append("order", ProductFormData.order);
      formdata.append("category", ProductFormData.category);
      formdata.append("discription", discription);
      formdata.append("productName", ProductFormData.ProductName);
      formdata.append("realPrice", ProductFormData.realprice);
      formdata.append("offerPrice", ProductFormData.OfferPrice);
      formdata.append("packsize", ProductFormData.packsize);
      formdata.append("unit", ProductFormData.unit);
      formdata.append("subtitle", ProductFormData.subtitle);
      formdata.append("mainImageIndex", mainImageIndex);
      formdata.append(
        "combo",
        JSON.stringify(
          comboItems.map(item => ({
            productName: item.product,
            quantity: item.quantity,
          }))
        )
      );
      formdata.append("stockQuantity", ProductFormData.stockQuantity);
      formdata.append(
        "servingsPerContainer",
        ProductFormData.servingsPerContainer?.trim() || ""
      );

      formdata.append(
        "servingSize",
        ProductFormData.servingSize?.trim() || ""
      );
      formdata.append("status", ProductFormData.status);
      formdata.append("sku", ProductFormData.sku);
      formdata.append("page_slug", ProductFormData.page_slug);
      formdata.append("removedImages", JSON.stringify(removedImages));



      if (ProductImage.length > 0) {
        ProductImage.forEach((image) => {
          formdata.append("productimage", image);
        });
      }

      let response = await axios.put(
        `${API}/api/product/editProduct/${idd}`,
        formdata,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 200) {

        showToast("Product updated successfully", "success");

        window.location.assign("/dashboard");
      }
    } catch (error) {

      if (error.response?.data?.message) {
        showToast(error.response.data.message, "error");
      } else {
        showToast("Something went wrong", "error");
      }

    }
  };

  useEffect(() => {
    if (EditProduct && idd) {

      setProductFormData(prev => ({
        ...prev,
        ProductName: EditProduct.productName ?? "",
        category: EditProduct.category ?? "",
        OfferPrice: EditProduct.offerPrice ?? "",
        realprice: EditProduct.realPrice ?? "",
        packsize: EditProduct.packsize ?? "",
        unit: EditProduct.unit ?? "",
        subtitle: EditProduct.subtitle ?? "",
        order: EditProduct.order ? String(EditProduct.order) : "",

        stockQuantity: EditProduct.stockQuantity ?? "",

        status: EditProduct.status ?? true,
        sku: EditProduct.sku ?? "",
        page_slug: EditProduct.page_slug ?? "",
        servingsPerContainer: EditProduct.servingsPerContainer ?? "",
        servingSize: EditProduct.servingSize ?? "",
      }));

      setComboItems(
        EditProduct.combo && EditProduct.combo.length > 0
          ? EditProduct.combo.map(item => ({
            product: item.productName,
            quantity: item.quantity,
          }))
          : []
      );
      setDiscription(EditProduct.discription || "");


      if (Array.isArray(EditProduct.productimage)) {
        const previews = EditProduct.productimage.map((img) => ({
          preview: img.url,
          fileName: img.fileName || "image",
          isMain: img.isMain || false,
          public_id: img.public_id,
        }));



        setPreviewImages(previews);
        const mainIndex = EditProduct.productimage.findIndex(img => img.isMain);
        setMainImageIndex(mainIndex !== -1 ? mainIndex : 0);

      }
    }
  }, [EditProduct, idd]);

  const navigate = useNavigate()
  const handleNavigate = () => {
    navigate("/dashboard");
  };

  const generateSlug = (text) => {
    return text
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  };

  const handleRemoveImage = (index) => {
    setPreviewImages(prev => {
      const imageToRemove = prev[index];

      if (imageToRemove.public_id) {
        setRemovedImages(r => [...r, imageToRemove.public_id]);
      }

      const updated = prev.filter((_, i) => i !== index);

      if (mainImageIndex === index) {
        setMainImageIndex(0);
      } else if (index < mainImageIndex) {
        setMainImageIndex(prev => prev - 1);
      }

      return updated;
    });
  };

  return (
    <div className="col-md-9 m-auto mt-3 p-3">
      <div className="row mt-2 cl">
        <div className="col-md-2  me-auto">
          <IoArrowBackCircleSharp className="fs-2 add-btns" onClick={handleNavigate} />
        </div>
      </div>
      <useToast position="top-right" autoClose={3000} />

      <div className="row mt-2 p-2">

        {INPUT_FIELDS.map(({ name, placeholder, col, type }) => (
          <div key={name} className={`col-md-${col} mb-3`}>
            <Form.Label>{placeholder}</Form.Label>

            <Form.Control
              type={type}
              name={name}
              value={ProductFormData[name] ?? ""}
              onChange={handleChange}
              placeholder={placeholder}
              min={type === "number" ? 0 : undefined}
              step={type === "number" ? "1" : undefined}
              required
              isInvalid={!!errors[name]}
            />

            <Form.Control.Feedback type="invalid">
              {errors[name]}
            </Form.Control.Feedback>

          </div>
        ))}


        {SELECT_FIELDS.map(({ name, col, options, placeholder }) => (
          <div key={name} className={`col-md-${col} mb-3`}>
            <Form.Select
              name={name}
              value={String(ProductFormData[name])}
              isInvalid={!!errors[name]}
              onChange={(e) =>
                setProductFormData(prev => ({
                  ...prev,
                  [name]:
                    name === "status"
                      ? e.target.value === "true"
                      : e.target.value,
                }))
              }
            >

              <option value="">{placeholder}</option>

              {options.map(opt =>
                typeof opt === "object" ? (
                  <option key={opt.label} value={String(opt.value)}>
                    {opt.label}
                  </option>
                ) : (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                )
              )}
            </Form.Select>
          </div>
        ))}

        {comboItems.length > 0 && (
          <div className="col-md-12 mb-3">
            <h6>Combo Content</h6>
            <small className="text-muted">
              Add products to combo. This will allow you to sell multiple products together as a bundle.
            </small>
          </div>
        )}

        {comboItems.length > 0 && comboItems.map((item, index) => (
          <div key={index} className="d-flex mb-2 gap-2 align-items-center">
            <input
              type="text"
              placeholder="Product Name"
              value={item.product}
              onChange={(e) => {
                const newCombo = [...comboItems];
                newCombo[index].product = e.target.value;
                setComboItems(newCombo);
              }}
              className="form-control"
            />
            <input
              type="number"
              min={1}
              value={item.quantity}
              onChange={(e) => {
                const newCombo = [...comboItems];
                newCombo[index].quantity = Number(e.target.value);
                setComboItems(newCombo);
              }}
              className="form-control"
              style={{ width: "100px" }}
            />
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => {
                setComboItems(comboItems.filter((_, i) => i !== index));
              }}
            >
              ×
            </button>
          </div>
        ))}
        <button
          type="button"
          className="add-btn p-2 col-md-6 m-auto mt-3"
          onClick={() => setComboItems([...comboItems, { product: "", quantity: 1 }])}
        >
          Add Product to Combo
        </button>



        <div className="col-md-12 mb-3">
          <h6 className="fw-bold mt-3">Inventory</h6>

          <Form.Label className="mt-2">Stock Quantity</Form.Label>
          <Form.Control
            type="number"
            placeholder="Enter available quantity (e.g. 50)"
            min="0"
            value={ProductFormData.stockQuantity}
            onChange={(e) =>
              setProductFormData(prev => ({
                ...prev,
                stockQuantity:
                  e.target.value === "" ? "" : Number(e.target.value),
              }))
            }
          />

          <small className="text-muted">
            Product will automatically be <b>Out of Stock</b> when quantity becomes 0.
          </small>
        </div>

        <div className="mt-2">
          <strong>
            Status:{" "}
            {ProductFormData.stockQuantity > 0
              ? <span className="text-success">In Stock</span>
              : <span className="text-danger">Out of Stock</span>}
          </strong>
        </div>



        <div className="col-md-6 mb-3">
          <Form.Label className="mb-0">Upload Images</Form.Label>
          <Form.Control
            multiple
            type="file"
            name="productimage"
            onChange={handleChangeImage}
          />
        </div>


        <div className="row mt-3">
          {previewImages.map((img, index) => (
            <div key={index} className="col-md-2 text-center position-relative">

              <img
                src={img.preview}
                height={100}
                width={120}
                className={`rounded border p-2 ${mainImageIndex === index
                  ? "border-success border-3"
                  : "border-secondary"
                  }`}
                style={{ cursor: "pointer", objectFit: "cover" }}
                onClick={() => setMainImageIndex(index)}
              />


              <button
                type="button"
                className="btn btn-danger btn-sm position-absolute top-0 end-0"
                onClick={() => handleRemoveImage(index)}
              >
                ×
              </button>

              <div className="small mt-1 text-truncate">{img.fileName}</div>

              {mainImageIndex === index && (
                <small className="text-success fw-bold">Main Image</small>
              )}
            </div>
          ))}
        </div>


      </div>

      <div className="row mt-3">
        <div>

          <CKEditor
            editor={ClassicEditor}
            data={discription}
            onChange={handleEditorChange}
            config={{
              autoGrow_onStartup: false,
              resize_enabled: false,
            }}
          />
          {errors.discription && (
            <div className="text-danger mt-1">{errors.discription}</div>
          )}
        </div>
      </div>

      <div className="row mt-3">

        <div className="col-md-2">
          <Button className="w-100" variant="dark" onClick={handleNavigate}>
            Cancel
          </Button>
        </div>

        < >
          {idd ? (
            <button className="col-md-4 m-auto mt-1 add-btn p-2 text-center"
              onClick={handleUpdate} variant="success">
              Update Product
            </button>
          ) : (
            <button className="col-md-2 me-auto mt-1 m-auto p-2 add-btn text-center"
              onClick={AddProduct} >
              Add Product
            </button>
          )}
        </>
      </div>
    </div>
  );
}
